import Type3 from "./footerType3";

export default Type3;
